/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { getCsvAutomationProduct , uploadCsvAutomationProduct } from '../../app/store/actions/automationProducts';
import ModalComponent from '../../components/modal';
import UploadFilesComponent from '../../components/upload';
import ImportErrors from '../../components/upload/ImportErrors';
import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';

class UploadAutomationProductsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      showModal: false,
      titleModal: '',
      titleModalBody: '',
      importMessage: null,
    };
  }

  sendFile = async (file) => {
    await this.setState({
      errors: {},
      importMessage: null,
    });

    try {
      const result = await this.props.uploadCsvAutomationProduct(file);
      await this.setState({
        errors: (result && result.errors) || [],
        importMessage: (result && result.created)
          ? I18n.t('successfulImportMessage', { 0: result.created })
          : null,
      });
      // eslint-disable-next-line no-empty
    } catch (error) { }
  }

  modelDownload = async () => {
    try {
      await this.props.getCsvAutomationProduct();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  goBack = () => {
    history.push(ROUTES.AUTOMATION_PRODUCTS);
  }

  render() {
    const {
      errors, showModal, titleModal, titleModalBody, importMessage,
    } = this.state;

    return (
      <div className="main-div-tables">
        <div className="main-table">

          <h2>{I18n.t('importProducts')}</h2>

          <div className="upload-text">
            <p>{`${I18n.t('importAutomationProductsText1')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importAutomationProductsText2')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importAutomationProductsText3')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importAutomationProductsText4')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
            <p>{`${I18n.t('importAutomationProductsText5')} `}<strong className="text-danger">{I18n.t('mandatory')}</strong></p>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
            importMessage={importMessage}
            itemsErrors={(
              <ImportErrors
                title={I18n.t('couponsNotAdded')}
                errorMessage="automationProducts"
                errors={errors}
              />
            )}
          />

          <ModalComponent
            title={titleModal}
            body={titleModalBody}
            visible={showModal}
            closeModal={() => this.setState({ showModal: false })}
            titleOkButtoon={I18n.t('ok')}
            size={{ width: '350px', height: '200px' }}
            showButtons
            confirmModal={() => this.setState({ showModal: false })}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadCsvAutomationProduct: file => dispatch(uploadCsvAutomationProduct(file)),
  getCsvAutomationProduct: () => dispatch(getCsvAutomationProduct()),
});

export default connect(null, mapDispatchToProps)(UploadAutomationProductsPage);
